import script from "./FAQItem.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQItem.vue?vue&type=script&setup=true&lang=js"

import "./FAQItem.vue?vue&type=style&index=0&id=3371fd27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3371fd27"]])

export default __exports__